// /app/frontend/src/data/examenBlancEleve.js
// Auto-évaluation native codevoiture.fr · basée sur la grille officielle d'évaluation du permis B
// 5 sections · ~32 critères · scoring proche du barème réel (admission >= 20/31 + aucun éliminatoire)

export const EXAMEN_BLANC_SECTIONS = [
  {
    id: 'installation',
    label: 'Installation à bord',
    color: 'sky',
    intro: "Avant même de tourner la clé : posture, ceinture, rétros, contact, démarrage en sécurité.",
    criteres: [
      { id: 'i1', label: "Régler le siège, le volant et les rétroviseurs", coef: 1 },
      { id: 'i2', label: "Attacher correctement sa ceinture et vérifier celle des passagers", coef: 1 },
      { id: 'i3', label: "Contrôler les indicateurs (carburant, témoins, frein de parking)", coef: 1 },
      { id: 'i4', label: "Démarrer en sécurité (embrayage, point mort, vérifications)", coef: 1 },
    ],
  },
  {
    id: 'manoeuvre',
    label: 'Manœuvres',
    color: 'amber',
    intro: "Le moment qui stresse le plus. L'examinateur juge ta précision, ton anticipation et ta lecture de l'environnement.",
    criteres: [
      { id: 'm1', label: "Réaliser un créneau (entre 2 véhicules)", coef: 1 },
      { id: 'm2', label: "Réaliser un stationnement en bataille (avant ou arrière)", coef: 1 },
      { id: 'm3', label: "Effectuer un demi-tour en sécurité", coef: 1 },
      { id: 'm4', label: "Faire marche arrière en ligne droite et en courbe", coef: 1 },
      { id: 'm5', label: "S'arrêter et redémarrer dans une côte (côte arrêtée)", coef: 1 },
    ],
  },
  {
    id: 'circulation',
    label: 'Circulation en ville et hors agglomération',
    color: 'red',
    intro: "Le cœur de l'examen : 25 à 30 min de conduite réelle. Tout y est observé.",
    criteres: [
      { id: 'c1', label: "Choisir la position correcte sur la chaussée", coef: 2 },
      { id: 'c2', label: "Adapter sa vitesse aux situations", coef: 2 },
      { id: 'c3', label: "Tourner à droite et à gauche en agglomération", coef: 2 },
      { id: 'c4', label: "Franchir des intersections (feu, stop, cédez le passage, rond-point)", coef: 2 },
      { id: 'c5', label: "Croiser, dépasser et être dépassé", coef: 2 },
      { id: 'c6', label: "S'insérer sur autoroute / voie rapide (insertion, dépassement, sortie)", coef: 2 },
      { id: 'c7', label: "Maintenir les distances de sécurité (règle des 2 secondes)", coef: 2 },
      { id: 'c8', label: "Utiliser les commandes (clignotants, feux, essuie-glaces) au bon moment", coef: 1 },
    ],
  },
  {
    id: 'autonomie',
    label: 'Autonomie de conduite',
    color: 'emerald',
    intro: "Pendant ~5 min, tu suis un itinéraire SEUL (panneaux, GPS). L'examinateur ne te guide plus.",
    criteres: [
      { id: 'a1', label: "Suivre un itinéraire indiqué par panneaux directionnels", coef: 1 },
      { id: 'a2', label: "Maintenir une conduite sûre et autonome", coef: 1 },
      { id: 'a3', label: "Gérer une erreur ou un imprévu sans paniquer", coef: 1 },
    ],
  },
  {
    id: 'verifications',
    label: 'Vérifications & questions',
    color: 'sky',
    intro: "L'examinateur peut te poser 2 questions : 1 vérification du véhicule + 1 question de sécurité routière.",
    criteres: [
      { id: 'v1', label: "Répondre à une question de vérification (intérieur ou extérieur du véhicule)", coef: 1 },
      { id: 'v2', label: "Répondre à une question de sécurité routière (premiers secours, alcool, fatigue…)", coef: 1 },
      { id: 'v3', label: "Conduire de manière éco-responsable (rapport, anticipation, ralenti…)", coef: 1 },
    ],
  },
];

export const ELIMINATOIRES = [
  "Mise en danger immédiate (pour soi, passagers ou autres usagers).",
  "Non-respect d'un panneau STOP ou d'un feu rouge.",
  "Franchissement d'une ligne continue.",
  "Non-respect des règles de priorité (refus de céder le passage).",
  "Conduite dangereuse (vitesse excessive, dépassement risqué).",
  "Intervention obligatoire de l'examinateur (frein, volant).",
];

// Calculer le score total possible
export const TOTAL_POSSIBLE = EXAMEN_BLANC_SECTIONS.reduce(
  (acc, sec) => acc + sec.criteres.reduce((s, c) => s + c.coef * 2, 0),
  0
);

// Calculer score actuel : 'acquis' = 2 pts × coef, 'progres' = 1 pt × coef, 'aRevoir' = 0
export function computeScore(results) {
  let total = 0;
  for (const sec of EXAMEN_BLANC_SECTIONS) {
    for (const c of sec.criteres) {
      const r = results[c.id];
      if (r === 'acquis') total += 2 * c.coef;
      else if (r === 'progres') total += 1 * c.coef;
    }
  }
  return total;
}

// Verdict basé sur le score : seuil de réussite ≈ 65 % (équivalent du 20/31 réel)
export function getVerdict(score, total, hasEliminatoire) {
  const pct = total > 0 ? (score / total) * 100 : 0;
  if (hasEliminatoire) {
    return { status: 'eliminatoire', label: 'Éliminatoire', color: 'red', desc: "Une faute éliminatoire suffit à recaler. Travaille en priorité ce point avec ton enseignant." };
  }
  if (pct >= 80) return { status: 'admis', label: 'Très bon niveau', color: 'emerald', desc: "Tu serais admis(e) avec une marge confortable. Continue comme ça." };
  if (pct >= 65) return { status: 'limite', label: 'Admissible', color: 'sky', desc: "Tu seras admis(e) si tu maintiens ce niveau le jour J. Quelques points à consolider." };
  if (pct >= 50) return { status: 'travail', label: 'Encore du travail', color: 'amber', desc: "Tu n'es pas encore prêt(e) pour l'examen. Cible les compétences en \"à revoir\"." };
  return { status: 'pas-pret', label: 'Pas encore prêt', color: 'red', desc: "Beaucoup de compétences ne sont pas acquises. Continue tes heures de conduite et refais ce bilan dans 2-3 semaines." };
}
